export default {
    'activities': 'Activities',
    'activity': 'Activity',
    'amount': 'Amount',
    'back': 'Back',
    'break': 'Break',
    'cancel': 'Cancel',
    'close': 'Close',
    'confirm_sync': 'There are unfinished activities. By continuing they will be finished.',
    'create': 'Create',
    'date': 'Date',
    'debug_and_tracking': 'Debug & tracking',
    'delete': 'Delete',
    'destroy': 'Destroy',
    'device': 'Device',
    'device_name': 'Device name',
    'duration': 'Duration',
    'edit': 'Edit',
    'edit_entry': 'Edit entry',
    'edit_activities': 'Edit activity order',
    'edit_rows': 'Edit rows order',
    'edit_teams': 'Edit teams order',
    'end_break': 'End break',
    'end_workday': 'End workday',
    'email': 'E-mailaddress',
    'employee': 'Employee',
    'end': 'Ended',
    'enter_pin': 'Enter pin',
    'enter_row_status': 'Select status',
    'enter_row_percentage': 'Select percentage',
    'enter_amount': 'Enter amount',
    'hidden': 'Hidden',
    'info': 'Info',
    'in_progress': 'Busy',
    'last_entries': 'Last entries',
    'location': 'Location | Locations',
    'login': 'Login',
    'logout': 'Logout',
    'menu': 'Menu',
    'name': 'Name',
    'no_packagings_yet': 'There are no packagings added yet',
    'no_registrations_yet': 'There have been no registrations yet',
    'packaging': 'Packaging',
    'password': 'Password',
    'pre_register_activities': 'Pre-register activities',
    'pre_registers': 'Registers beforehand',
    'register_activities': 'Register activities',
    'register_device': 'Register device',
    'register_workdays': 'Register workdays',
    'registers': 'Registers',
    'remember_me': 'Remember me',
    'reset': 'reset',
    'row': 'Row',
    'row_as_buttons': 'Show rows as buttons',
    'row_status': 'Row status',
    'rows': 'Rows',
    'rows_as_buttons': 'Show rows as buttons',
    'save': 'Save',
    'select': 'Select',
    'select_a_packaging': 'Select a packaging',
    'select_a_row': 'Select a row',
    'select_a_row_status': 'Select a row status',
    'select_a_team': 'Select a team',
    'select_an_activity': 'Select an activity',
    'select_an_employee': 'Select an employee',
    'select_location': 'Select a location',
    'shown': 'Shown',
    'select_activity': 'Select an activity',
    'select_packaging': 'Select a type of packaging',
    'select_row': 'Enter row number',
    'sort_activities': 'Sort activities',
    'sort_rows': 'Sort rows',
    'sort_teams': 'Sort teams',
    'start': 'Started',
    'start_break': 'Start break',
    'start_workday': 'Start workday',
    'store': 'Store',
    'synchronise': 'Synchronise',
    'synchronise_settings': 'Synchronise settings',
    'team': 'Team',
    'teams': 'Teams',
    'teams_as_buttons': 'Show teams as buttons',
    'to_approve': 'To approve',
    'uuid': 'Device ID',
    'version': 'Version',
    'workdays': 'Workdays',
    'settings': 'Settings',
    'pin_visible': 'PIN visible',
  'dark_mode': 'Dark mode',
  'choose_existing_device': 'Kies een bestaand apparaat',
  'create_new_device': 'Maak een nieuw apparaat aan'
}
